import { render, staticRenderFns } from "./TaxCustomerFormCreate.vue?vue&type=template&id=af61ad48&scoped=true&"
import script from "./TaxCustomerFormCreate.vue?vue&type=script&lang=js&"
export * from "./TaxCustomerFormCreate.vue?vue&type=script&lang=js&"
import style0 from "./TaxCustomerFormCreate.vue?vue&type=style&index=0&id=af61ad48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af61ad48",
  null
  
)

export default component.exports